import { Component } from "@angular/core";

@Component({
    selector: "cefi-subscription-expired-page",
    templateUrl: "./subscription-expired-page.component.html",
    styleUrls: ["./subscription-expired-page.component.css"],
})
export class SubscriptionExpiredPageComponent {}
